export default __webpack_public_path__ + "static/streamlining-claims-processing-with-robotic-process-automation-RPA-799b853922c55ca0eaaf36edd1f92209.png";